import { render } from "./MessagesSidePanel.vue?vue&type=template&id=9d91f2c0&scoped=true"
import script from "./MessagesSidePanel.vue?vue&type=script&lang=js"
export * from "./MessagesSidePanel.vue?vue&type=script&lang=js"

import "./MessagesSidePanel.vue?vue&type=style&index=0&id=9d91f2c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d91f2c0"]])

export default __exports__